import { Autocomplete, Box } from "@mui/material";
import CancelButton from "Common/Components/Buttons/CancelButton";
import { DeleteButton } from "Common/Components/Buttons/DeleteButton";
import EditButton from "Common/Components/Buttons/EditButton";
import PrimarySubmitButton from "Common/Components/Buttons/PrimarySubmitButton";
import ToggleButton from "Common/Components/Buttons/ToggleButton";
import FileUploadInput from "Common/Components/FileUploadInput/FileUploadInput";
import BootstrapTextField from "Common/Components/InputComponent/BootstrapTextField";
import NewFileUploadInput from "components/FilePreview/FileInputPreview";
import FilePreview2 from "components/FilePreview/FilePreview2";
import { autocompleteDropdownStyles } from "Constants/Style";
import { City, Country, State } from "country-state-city";
import React, { useEffect, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import { fetchAddressFromPincode } from "helpers/geonamesHelper";

interface FormikTypes {
  is_primary: boolean;
  branch_name: string;
  branch_email: string;
  branch_phone_number: string;
  contact_name: string;
  contact_email: string;
  contact_phone_number: string;
  is_gst_details: boolean;
  gst_document_name: string;
  gst_document: string;
  address: string;
  pincode: string;
  city: any;
  state: any;
  country: any;
}

const BranchDetails: React.FC<any> = ({
  goToTab,
  branches,
  setBranches,
  branchFormik,
  editBranchIndex,
  setEditBranchIndex,
  handleBranchNext,
  countries,
  setCountries,
  states,
  setStates,
  cities,
  setCities,
}) => {
  const [showBranchDetails, setShowBranchDetails] = useState<{
    [key: number]: boolean;
  }>({});

  const handlePincodeBlur = async () => {
    const pin = branchFormik.values.pincode?.trim();
    if (!pin) return;

    const selectedCountry = countries.find(
      (c: any) => c.name === branchFormik.values.country
    );
    const countryCode = selectedCountry?.isoCode;

    try {
      const data = await fetchAddressFromPincode(pin, countryCode);
      if (data) {
        const resolvedCountry = countries.find(
          (c: any) => c.isoCode === data.countryCode
        ) || Country.getAllCountries().find(
          (c: any) => c.isoCode === data.countryCode
        );

        if (resolvedCountry) {
          branchFormik.setFieldValue("country", resolvedCountry.name);

          const countryStates = State.getStatesOfCountry(resolvedCountry.isoCode);
          setStates(countryStates);

          const resolvedState = countryStates.find(
            (s: any) =>
              s.name?.toLowerCase() === data.adminName1?.toLowerCase() ||
              s.isoCode?.toLowerCase() === data.adminCode1?.toLowerCase()
          );

          if (resolvedState) {
            branchFormik.setFieldValue("state", resolvedState.name);

            const stateCities = City.getCitiesOfState(
              resolvedCountry.isoCode,
              resolvedState.isoCode
            );
            setCities(stateCities);
            branchFormik.setFieldValue("city", data.placeName || "");
          } else {
            branchFormik.setFieldValue("state", data.adminName1 || "");
            branchFormik.setFieldValue("city", data.placeName || "");
          }
        }
      }
    } catch (err) {
      console.error("Failed to fetch address details for pincode", err);
    }
  };

  const toggleBranch = (index: number) => {
    setShowBranchDetails((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleNext = async () => {
    if (branches.length === 0) {
      Swal?.fire({
        icon: "warning",
        text: "Please add at least one branch before proceeding.",
      });
      return;
    }

    const hasPrimaryBranch = branches.some((branch: any) => branch?.is_primary);
    if (!hasPrimaryBranch) {
      Swal?.fire({
        icon: "warning",
        text: "Please select at least one branch as Primary.",
      });
      return;
    }

    goToTab("price");
  };

  const handleDeleteBranch = (index: number) => {
    const updatedBranch = branches?.filter((_: any, i: number) => i !== index);
    setBranches(updatedBranch);
  };
  const handleEditBranch = (index: number) => {
    const selectedEditBranch = branches[index];
    branchFormik.setFieldValue("is_primary", selectedEditBranch?.is_primary);
    branchFormik.setFieldValue("branch_name", selectedEditBranch?.branch_name);
    branchFormik.setFieldValue(
      "branch_email",
      selectedEditBranch?.branch_email,
    );
    branchFormik.setFieldValue(
      "branch_phone_number",
      selectedEditBranch?.branch_phone_number,
    );
    branchFormik.setFieldValue(
      "contact_name",
      selectedEditBranch?.contact_name,
    );
    branchFormik.setFieldValue(
      "contact_email",
      selectedEditBranch?.contact_email,
    );
    branchFormik.setFieldValue(
      "contact_phone_number",
      selectedEditBranch?.contact_phone_number,
    );
    branchFormik.setFieldValue(
      "is_gst_details",
      selectedEditBranch?.is_gst_details,
    );
    branchFormik.setFieldValue(
      "gst_document_name",
      selectedEditBranch?.gst_document_name,
    );
    branchFormik.setFieldValue(
      "gst_document",
      selectedEditBranch?.gst_document,
    );
    branchFormik.setFieldValue("address", selectedEditBranch?.address);
    branchFormik.setFieldValue("pincode", selectedEditBranch?.pincode);
    branchFormik.setFieldValue("city", selectedEditBranch?.city);
    branchFormik.setFieldValue("state", selectedEditBranch?.state);
    branchFormik.setFieldValue("country", selectedEditBranch?.country);
    setEditBranchIndex(index);
  };

  useEffect(() => {
    console.log("branchFormik => ", branchFormik.values);
  }, [branchFormik.values]);

  return (
    <div>
      <Card
        style={{
          border: "1px solid #e5e7eb",
          borderRadius: "6px",
          marginBottom: "16px",
          padding: "16px 20px",
          boxShadow: "none",
          cursor: "pointer",
        }}
      >
        <div>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div style={{ fontWeight: 600 }}>{`Branch - 1`}</div>
          </div>
          <Form.Check
            type="checkbox"
            label="Set as Primary Branch"
            style={{ fontWeight: 500 }}
            checked={branchFormik.values.is_primary}
            onChange={(e) => {
              branchFormik.setFieldValue("is_primary", e.target.checked);
            }}
          />
        </div>
        <Form>
          <hr />
          <Row className="mb-3 gy-3">
            <Col xs={12} md={3} lg={4}>
              <Form.Label style={{ fontWeight: 600 }}>
                Branch Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                placeholder="Enter Branch Name"
                id="branch_name"
                name="branch_name"
                value={branchFormik.values.branch_name}
                onChange={branchFormik.handleChange}
                onBlur={branchFormik.handleBlur}
                isInvalid={
                  !!(
                    branchFormik.touched.branch_name &&
                    branchFormik.errors.branch_name
                  )
                }
              />
              <Form.Control.Feedback type="invalid">
                {branchFormik.errors.branch_name}
              </Form.Control.Feedback>
            </Col>

            <Col xs={12} md={3} lg={4}>
              <Form.Label style={{ fontWeight: 600 }}>
                Email <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                placeholder="Enter Email"
                id="branch_email"
                name="branch_email"
                value={branchFormik.values.branch_email}
                onChange={branchFormik.handleChange}
                onBlur={branchFormik.handleBlur}
                isInvalid={
                  !!(
                    branchFormik.touched.branch_email &&
                    branchFormik.errors.branch_email
                  )
                }
              />
              <Form.Control.Feedback type="invalid">
                {branchFormik.errors.branch_email}
              </Form.Control.Feedback>
            </Col>

            <Col xs={12} md={3} lg={4}>
              <Form.Label style={{ fontWeight: 600 }}>
                Phone No. <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="branch_phone_number"
                name="branch_phone_number"
                placeholder="Enter Phone No."
                value={branchFormik.values.branch_phone_number}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^\d+\s()-]/g, "");
                  branchFormik.setFieldValue("branch_phone_number", value);
                }}
                onBlur={branchFormik.handleBlur}
                isInvalid={
                  !!(
                    branchFormik.touched.branch_phone_number &&
                    branchFormik.errors.branch_phone_number
                  )
                }
              />
              <Form.Control.Feedback type="invalid">
                {branchFormik.errors.branch_phone_number}
              </Form.Control.Feedback>
            </Col>
            <Col xs={12} md={3} lg={4}>
              <Form.Label style={{ fontWeight: 600 }}>
                Contact Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                placeholder="Enter Contact Name"
                id="contact_name"
                name="contact_name"
                value={branchFormik.values.contact_name}
                onChange={branchFormik.handleChange}
                onBlur={branchFormik.handleBlur}
                isInvalid={
                  !!(
                    branchFormik.touched.contact_name &&
                    branchFormik.errors.contact_name
                  )
                }
              />
              <Form.Control.Feedback type="invalid">
                {branchFormik.errors.contact_name}
              </Form.Control.Feedback>
            </Col>

            <Col xs={12} md={3} lg={4}>
              <Form.Label style={{ fontWeight: 600 }}>
                Contact Email <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                placeholder="Enter Email"
                id="contact_email"
                name="contact_email"
                value={branchFormik.values.contact_email}
                onChange={branchFormik.handleChange}
                onBlur={branchFormik.handleBlur}
                isInvalid={
                  !!(
                    branchFormik.touched.contact_email &&
                    branchFormik.errors.contact_email
                  )
                }
              />
              <Form.Control.Feedback type="invalid">
                {branchFormik.errors.contact_email}
              </Form.Control.Feedback>
            </Col>

            <Col xs={12} md={3} lg={4}>
              <Form.Label style={{ fontWeight: 600 }}>
                Contact Phone No. <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="contact_phone_number"
                name="contact_phone_number"
                placeholder="Enter Contact Phone No."
                value={branchFormik.values.contact_phone_number}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^\d+\s()-]/g, "");
                  branchFormik.setFieldValue("contact_phone_number", value);
                }}
                onBlur={branchFormik.handleBlur}
                isInvalid={
                  !!(
                    branchFormik.touched.contact_phone_number &&
                    branchFormik.errors.contact_phone_number
                  )
                }
              />
              <Form.Control.Feedback type="invalid">
                {branchFormik.errors.contact_phone_number}
              </Form.Control.Feedback>
            </Col>
          </Row>
          <hr />
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="is_gst_details"
              checked={branchFormik?.values?.is_gst_details}
              onChange={(e) => {
                branchFormik.setFieldValue("is_gst_details", e.target.checked);
              }}
              style={{
                width: "16px",
                height: "16px",
                borderRadius: "0px",
                backgroundColor: branchFormik?.values?.is_gst_details
                  ? "#0CBA91"
                  : "",
                borderColor: branchFormik?.values?.is_gst_details
                  ? "#0CBA91"
                  : "",
              }}
            />
            <label className="form-check-label" htmlFor="is_gst_details">
              GST Details
            </label>
          </div>

          {branchFormik?.values?.is_gst_details && (
            <Row className="mb-3">
              <Col xs={12} md={4} lg={4}>
                <Form.Label style={{ fontWeight: 600 }}>
                  GST No. <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  placeholder="Enter GST No."
                  id="gst_document_name"
                  name="gst_document_name"
                  value={branchFormik.values.gst_document_name}
                  onChange={branchFormik.handleChange}
                  onBlur={branchFormik.handleBlur}
                  isInvalid={
                    !!(
                      branchFormik.touched.gst_document_name &&
                      branchFormik.errors.gst_document_name
                    )
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {branchFormik.errors.gst_document_name}
                </Form.Control.Feedback>
              </Col>

              <Col xs={12} md={4} lg={4}>
                <NewFileUploadInput
                  label="GST Document"
                  name="gst_document"
                  required={branchFormik?.values?.is_gst_details}
                  formik={branchFormik}
                />
              </Col>
            </Row>
          )}
          <hr />
          <Row className="mb-3 gy-3">
            <Col xs={12} md={3} lg={4}>
              <Form.Label style={{ fontWeight: 600 }}>
                Address <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                placeholder="Enter Address"
                id="address"
                name="address"
                value={branchFormik.values.address}
                onChange={branchFormik.handleChange}
                onBlur={branchFormik.handleBlur}
                isInvalid={
                  !!(
                    branchFormik.touched.address && branchFormik.errors.address
                  )
                }
              />
              <Form.Control.Feedback type="invalid">
                {branchFormik.errors.address}
              </Form.Control.Feedback>
            </Col>

            <Col xs={12} md={3} lg={4}>
              <Form.Label>
                Pincode <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="pincode"
                name="pincode"
                maxLength={6}
                placeholder="Enter Pincode"
                value={branchFormik.values.pincode}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[0-9\s]*$/g.test(value)) {
                    branchFormik.setFieldValue("pincode", value);
                  }
                }}
                onBlur={(e) => {
                  branchFormik.handleBlur(e);
                  handlePincodeBlur();
                }}
                isInvalid={
                  !!branchFormik.errors.pincode && branchFormik.touched.pincode
                }
              />
              <Form.Control.Feedback type="invalid">
                {branchFormik.errors.pincode}
              </Form.Control.Feedback>
            </Col>

            <Col xs={12} md={3} lg={4}>
              <Form.Label>
                Country <span className="text-danger">*</span>
              </Form.Label>
              <Autocomplete
                size="small"
                options={countries || []}
                autoHighlight
                value={
                  countries.find(
                    (c: any) =>
                      c.name?.toLowerCase() ===
                      (typeof branchFormik.values.country === "object"
                        ? branchFormik.values.country?.name
                        : branchFormik.values.country
                      )?.toLowerCase(),
                  ) || null
                }
                isOptionEqualToValue={(option: any, value: any) => {
                  if (!value) return false;
                  const valueName =
                    typeof value === "object" ? value.name : value;
                  return (
                    option?.name?.toLowerCase() === valueName?.toLowerCase()
                  );
                }}
                onChange={(_, val) => {
                  branchFormik.setFieldValue("country", val);
                  branchFormik.setFieldValue("state", "");
                  branchFormik.setFieldValue("city", "");
                  if (val) {
                    const newStates = State.getStatesOfCountry(val?.isoCode);
                    setStates(newStates);
                    setCities([]);
                  }
                }}
                onBlur={() => branchFormik.setFieldTouched("country", true)}
                getOptionLabel={(option: any) =>
                  option ? option?.name : option
                }
                ListboxProps={autocompleteDropdownStyles.ListboxProps}
                renderOption={(props, option) =>
                  autocompleteDropdownStyles.renderOption(
                    props,
                    option,
                    (opt) => opt.name,
                  )
                }
                renderInput={(params) => (
                  <BootstrapTextField
                    {...params}
                    placeholder="Select Country"
                    id="country"
                    name="country"
                    error={
                      branchFormik.touched.country &&
                      Boolean(branchFormik.errors.country)
                    }
                    helperText={
                      branchFormik.touched.country &&
                      typeof branchFormik.errors.country === "string"
                        ? branchFormik.errors.country
                        : undefined
                    }
                    sx={{
                      ...autocompleteDropdownStyles.inputSx,
                    }}
                  />
                )}
              />
            </Col>
            <Col xs={12} md={3} lg={4}>
              <Form.Label>
                {states.length > 0 ? "State" : "State / Region"}{" "}
                {states.length > 0 && <span className="text-danger">*</span>}
              </Form.Label>
              {states.length > 0 ? (
                <Autocomplete
                  size="small"
                  options={states || []}
                  autoHighlight
                  disabled={!branchFormik.values.country}
                  value={
                    states.find(
                      (s: any) =>
                        s.name?.toLowerCase() ===
                        (typeof branchFormik.values.state === "object"
                          ? branchFormik.values.state?.name
                          : branchFormik.values.state
                        )?.toLowerCase(),
                    ) || null
                  }
                  isOptionEqualToValue={(option: any, value: any) => {
                    if (!value) return false;
                    const valueName =
                      typeof value === "object" ? value.name : value;
                    return (
                      option?.name?.toLowerCase() === valueName?.toLowerCase()
                    );
                  }}
                  onChange={(_, val) => {
                    branchFormik.setFieldValue("state", val);
                    branchFormik.setFieldValue("city", "");
                    if (branchFormik?.values?.country && val) {
                      const newCities = City.getCitiesOfState(
                        branchFormik?.values?.country?.isoCode ?? "",
                        val.isoCode,
                      );
                      setCities(newCities || []);
                    } else {
                      setCities([]);
                    }
                  }}
                  onBlur={() => branchFormik.setFieldTouched("state", true)}
                  getOptionLabel={(option: any) =>
                    option ? option?.name : option
                  }
                  ListboxProps={autocompleteDropdownStyles.ListboxProps}
                  renderOption={(props, option) =>
                    autocompleteDropdownStyles.renderOption(
                      props,
                      option,
                      (opt) => opt.name,
                    )
                  }
                  renderInput={(params) => (
                    <BootstrapTextField
                      {...params}
                      placeholder="Select State"
                      id="state"
                      name="state"
                      error={
                        branchFormik.touched.state &&
                        Boolean(branchFormik.errors.state)
                      }
                      helperText={
                        branchFormik.touched.state &&
                        typeof branchFormik.errors.state === "string"
                          ? branchFormik.errors.state
                          : undefined
                      }
                      sx={{
                        ...autocompleteDropdownStyles.inputSx,
                      }}
                    />
                  )}
                />
              ) : (
                <Form.Control
                  id="state"
                  name="state"
                  placeholder="Enter State / Region"
                  value={
                    typeof branchFormik.values.state === "object"
                      ? branchFormik.values.state?.name || ""
                      : branchFormik.values.state || ""
                  }
                  onChange={branchFormik.handleChange}
                  disabled={!branchFormik.values.country}
                />
              )}
            </Col>
            <Col xs={12} md={3} lg={4}>
              {(() => {
                const hasStates = states.length > 0;
                const hasCities = cities.length > 0;
                const showCityDropdown =
                  hasStates && (!branchFormik.values.state || hasCities);

                return (
                  <>
                    <Form.Label>
                      City{" "}
                      {showCityDropdown && (
                        <span className="text-danger">*</span>
                      )}
                    </Form.Label>
                    {showCityDropdown ? (
                      <Autocomplete
                        disabled={!branchFormik.values.state}
                        size="small"
                        options={cities || []}
                        autoHighlight
                        value={
                          cities.find(
                            (c: any) =>
                              c.name?.toLowerCase() ===
                              (typeof branchFormik.values.city === "object"
                                ? branchFormik.values.city?.name
                                : branchFormik.values.city
                              )?.toLowerCase(),
                          ) || null
                        }
                        isOptionEqualToValue={(option: any, value: any) => {
                          if (!value) return false;
                          const valueName =
                            typeof value === "object" ? value.name : value;
                          return (
                            option?.name?.toLowerCase() ===
                            valueName?.toLowerCase()
                          );
                        }}
                        onChange={(_, val) => {
                          branchFormik.setFieldValue("city", val);
                        }}
                        onBlur={() =>
                          branchFormik.setFieldTouched("city", true)
                        }
                        getOptionLabel={(option: any) =>
                          option ? option?.name : option
                        }
                        ListboxProps={autocompleteDropdownStyles.ListboxProps}
                        renderOption={(props, option) =>
                          autocompleteDropdownStyles.renderOption(
                            props,
                            option,
                            (opt) => opt.name,
                          )
                        }
                        renderInput={(params) => (
                          <BootstrapTextField
                            {...params}
                            placeholder="Select City"
                            id="city"
                            name="city"
                            error={
                              branchFormik.touched.city &&
                              Boolean(branchFormik.errors.city)
                            }
                            helperText={
                              branchFormik.touched.city &&
                              typeof branchFormik.errors.city === "string"
                                ? branchFormik.errors.city
                                : undefined
                            }
                            sx={{
                              ...autocompleteDropdownStyles.inputSx,
                            }}
                          />
                        )}
                      />
                    ) : (
                      <Form.Control
                        id="city"
                        name="city"
                        placeholder="Enter City"
                        value={
                          typeof branchFormik.values.city === "object"
                            ? branchFormik.values.city?.name || ""
                            : branchFormik.values.city || ""
                        }
                        onChange={branchFormik.handleChange}
                        disabled={!branchFormik.values.country}
                      />
                    )}
                  </>
                );
              })()}
            </Col>
          </Row>
        </Form>
      </Card>
      {/* Add Branch Button */}
      <div className="d-flex justify-content-end mb-3">
        <CancelButton
          onClick={() => branchFormik.handleSubmit()}
          showConfirmation={false}
          label={`${editBranchIndex !== null ? "Save" : "+ Add Branch"} `}
        />
      </div>
      {/* ======================Branch Listing is below=================================== */}
      {branches?.map((branch: any, index: number) => {
        return (
          <>
            <Card
              // key={branch.id}
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "6px",
                marginBottom: "16px",
                padding: "16px 20px",
                boxShadow: "none",
                cursor: "pointer",
              }}
            >
              <div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div style={{ fontWeight: 600 }}>{`Branch - ${index + 1} (${
                    branch?.branch_name
                  })`}</div>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      {/* Toggle Branch Details */}
                      <ToggleButton
                        isOpen={showBranchDetails[index] || false}
                        onClick={() => toggleBranch(index)}
                        title="Toggle branch details"
                      />

                      {/* Edit and Delete Branch */}
                      <EditButton onClick={() => handleEditBranch(index)} />
                      <DeleteButton onClick={() => handleDeleteBranch(index)} />
                    </div>
                  </td>
                </div>
                <Form.Check
                  type="checkbox"
                  readOnly
                  label="Set as Primary Branch"
                  style={{ fontWeight: 500 }}
                  checked={branch.is_primary}
                  onChange={(e) => {
                    // branchFormik.setFieldValue('is_primary', e.target.checked);
                  }}
                />
              </div>
              {showBranchDetails[index] && (
                <Form>
                  <hr />
                  <Row className="mb-3 gy-3">
                    <Col xs={12} md={3} lg={4}>
                      <Form.Label style={{ fontWeight: 600 }}>
                        Branch Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        readOnly
                        name="branch_name"
                        value={branch?.branch_name}
                      />
                    </Col>

                    <Col xs={12} md={3} lg={4}>
                      <Form.Label style={{ fontWeight: 600 }}>
                        Email <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        readOnly
                        placeholder="Enter Email"
                        name="branch_email"
                        value={branch?.branch_email}
                      />
                    </Col>

                    <Col xs={12} md={3} lg={4}>
                      <Form.Label style={{ fontWeight: 600 }}>
                        Phone No. <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        name="branch_phone_number"
                        value={branch?.branch_phone_number}
                      />
                    </Col>
                    <Col xs={12} md={3} lg={4}>
                      <Form.Label style={{ fontWeight: 600 }}>
                        Contact Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        readOnly
                        placeholder="Enter Contact Name"
                        name="contact_name"
                        value={branch?.contact_name}
                      />
                    </Col>

                    <Col xs={12} md={3} lg={4}>
                      <Form.Label style={{ fontWeight: 600 }}>
                        Contact Email <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        readOnly
                        placeholder="Enter Email"
                        name="contact_email"
                        value={branch?.contact_email}
                      />
                    </Col>

                    <Col xs={12} md={3} lg={4}>
                      <Form.Label style={{ fontWeight: 600 }}>
                        Contact Phone No. <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        name="contact_phone_number"
                        value={branch?.contact_phone_number}
                      />
                    </Col>
                  </Row>
                  <hr />
                  <span style={{ fontWeight: 500, marginTop: 5 }}>
                    GST Document
                  </span>
                  {branch?.is_gst_details && (
                    <Row className="mb-3 mt-2">
                      <Col xs={12} md={4} lg={4}>
                        <Form.Label style={{ fontWeight: 600 }}>
                          GST Document Name
                        </Form.Label>
                        <Form.Control
                          readOnly
                          placeholder="Enter GST Document Name"
                          name="gst_document_name"
                          value={branch?.gst_document_name}
                        />
                      </Col>

                      <Col xs={12} md={4} lg={4}>
                        <Form.Label style={{ fontWeight: 600 }}>
                          GST Document
                        </Form.Label>
                        <FilePreview2 file={branch?.gst_document} />
                      </Col>
                    </Row>
                  )}
                  <hr />
                  <Row className="mb-3 gy-3">
                    <Col xs={12} md={3} lg={4}>
                      <Form.Label style={{ fontWeight: 600 }}>
                        Address <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        placeholder="Enter Address"
                        name="address"
                        value={branch?.address}
                        readOnly
                      />
                    </Col>

                    <Col xs={12} md={3} lg={4}>
                      <Form.Label>
                        Country <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        readOnly
                        value={
                          typeof branch?.country === "object"
                            ? branch?.country?.name
                            : branch?.country
                        }
                      />
                    </Col>
                    <Col xs={12} md={3} lg={4}>
                      <Form.Label>
                        State <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        readOnly
                        value={
                          typeof branch?.state === "object"
                            ? branch?.state?.name
                            : branch?.state
                        }
                      />
                    </Col>
                    <Col xs={12} md={3} lg={4}>
                      <Form.Label>
                        City <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        readOnly
                        value={
                          typeof branch?.city === "object"
                            ? branch?.city?.name
                            : branch?.city
                        }
                      />
                    </Col>
                    <Col xs={12} md={3} lg={4}>
                      <Form.Label>
                        Pincode <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        name="pincode"
                        placeholder="Enter Pincode"
                        value={branch?.pincode}
                      />
                    </Col>
                  </Row>
                </Form>
              )}
            </Card>
          </>
        );
      })}
      {/* ================================================================================ */}
      <div className="d-flex flex-wrap justify-content-center gap-3 mt-5">
        <PrimarySubmitButton
          type="button"
          label="Prev"
          onClick={() => goToTab("kyc")}
          className="px-4 mb-2"
        />
        <PrimarySubmitButton
          type="button"
          label="Next"
          onClick={() => handleBranchNext()}
          className="px-4 mb-2"
        />
      </div>
    </div>
  );
};

export default BranchDetails;
